import { render, staticRenderFns } from "./FamiliariView.vue?vue&type=template&id=050c9e8b&"
import script from "./FamiliariView.vue?vue&type=script&lang=js&"
export * from "./FamiliariView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports